import { IAvailableFeatureData } from "components/features/types";
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type TAvailableFeaturesState from "./type";

const initialState: TAvailableFeaturesState = {
  data: [],
};

export const availableFeaturesSlice = createSlice({
  name: "availableFeatures",
  initialState,
  reducers: {
    setFeatures: (
      state: TAvailableFeaturesState,
      action: PayloadAction<IAvailableFeatureData[]>,
    ) => {
      state.data = action.payload;
    },
  },
});

// Actions
export const { setFeatures } = availableFeaturesSlice.actions;

export default availableFeaturesSlice.reducer;
